(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caprilac-barra-de-anuncios"] && !Shopify.designMode) return;
  try {
    
(function () {
  var temporizadores = new WeakMap();

  function iniciarRotador(contenedor) {
    var mensajes = contenedor.querySelectorAll('[data-caprilac-anuncio]');
    if (mensajes.length < 2) return;

    var anterior = temporizadores.get(contenedor);
    if (anterior) window.clearInterval(anterior);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var intervalo = (parseFloat(contenedor.dataset.intervalo) || 5) * 1000;
    var indice = 0;

    var id = window.setInterval(function () {
      mensajes[indice].classList.remove('esta-activo');
      indice = (indice + 1) % mensajes.length;
      mensajes[indice].classList.add('esta-activo');
    }, intervalo);

    temporizadores.set(contenedor, id);
  }

  function iniciarTodos(raiz) {
    var ambito = raiz || document;
    ambito.querySelectorAll('[data-caprilac-anuncios]').forEach(iniciarRotador);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos();
    });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodos(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caprilac-carrusel-productos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarCarrusel(seccion) {
    var riel = seccion.querySelector('[data-caprilac-riel]');
    if (!riel) return;

    var anterior = seccion.querySelector('[data-caprilac-anterior]');
    var siguiente = seccion.querySelector('[data-caprilac-siguiente]');
    var avance = seccion.querySelector('[data-caprilac-avance]');
    var barra = seccion.querySelector('[data-caprilac-barra]');

    function paso() {
      var tarjeta = riel.querySelector('[data-caprilac-tarjeta]');
      if (!tarjeta) return riel.clientWidth;
      var estilos = window.getComputedStyle(riel);
      var hueco = parseFloat(estilos.columnGap || estilos.gap) || 0;
      return tarjeta.getBoundingClientRect().width + hueco;
    }

    function maximo() {
      return Math.max(0, riel.scrollWidth - riel.clientWidth);
    }

    function actualizar() {
      var tope = maximo();

      if (anterior) anterior.disabled = riel.scrollLeft <= 2;
      if (siguiente) siguiente.disabled = riel.scrollLeft >= tope - 2;

      if (barra) {
        if (tope <= 2) {
          barra.style.display = 'none';
          return;
        }
        barra.style.display = '';
      }

      if (avance) {
        var proporcion = Math.min(1, riel.clientWidth / riel.scrollWidth);
        var recorrido = tope > 0 ? riel.scrollLeft / tope : 0;
        avance.style.width = proporcion * 100 + '%';
        avance.style.transform = 'translateX(' + recorrido * (100 / proporcion - 100) + '%)';
      }
    }

    if (anterior) {
      anterior.addEventListener('click', function () {
        riel.scrollBy({ left: -paso(), behavior: 'smooth' });
      });
    }

    if (siguiente) {
      siguiente.addEventListener('click', function () {
        riel.scrollBy({ left: paso(), behavior: 'smooth' });
      });
    }

    riel.addEventListener('scroll', function () {
      window.requestAnimationFrame(actualizar);
    });

    window.addEventListener('resize', actualizar);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(actualizar).observe(riel);
    }

    actualizar();
  }

  function iniciarTodos(raiz) {
    var ambito = raiz || document;
    ambito.querySelectorAll('[data-caprilac-carrusel]').forEach(iniciarCarrusel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos();
    });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodos(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caprilac-coleccion"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarColeccion(seccion) {
    var botones = seccion.querySelectorAll('[data-caprilac-filtro]');
    var tarjetas = seccion.querySelectorAll('[data-caprilac-tarjeta]');
    var vacio = seccion.querySelector('[data-caprilac-vacio]');

    if (!botones.length || !tarjetas.length) return;

    function aplicar(clave) {
      var visibles = 0;

      tarjetas.forEach(function (tarjeta) {
        var claves = (tarjeta.getAttribute('data-claves') || '').split(' ');
        var coincide = clave === 'todos' || claves.indexOf(clave) !== -1;
        tarjeta.hidden = !coincide;
        if (coincide) visibles++;
      });

      if (vacio) vacio.hidden = visibles > 0;
    }

    botones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        botones.forEach(function (otro) {
          otro.classList.remove('esta-activo');
        });
        boton.classList.add('esta-activo');
        aplicar(boton.getAttribute('data-caprilac-filtro'));
      });
    });
  }

  function iniciarTodos(raiz) {
    var ambito = raiz || document;
    ambito.querySelectorAll('[data-caprilac-coleccion]').forEach(iniciarColeccion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos();
    });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodos(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caprilac-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarFaq(seccion) {
    if (!seccion.classList.contains('caprilac-faq--exclusiva')) return;

    var items = seccion.querySelectorAll('[data-caprilac-item]');

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (otro) {
          if (otro !== item && otro.open) {
            otro.open = false;
          }
        });
      });
    });
  }

  function iniciarTodos(raiz) {
    var ambito = raiz || document;
    ambito.querySelectorAll('[data-caprilac-faq]').forEach(iniciarFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos();
    });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodos(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
